import React from 'react';

export const BathroomsIcon = props => (
  <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#545D69" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.206 5.97v-.382a4.206 4.206 0 018.412 0v13.765" />
      <path d="M7.265 9.03a3.059 3.059 0 00-6.118 0v.764h6.118V9.03h0z" />
      <path
        strokeLinecap="round"
        d="M4.206 14v-1.529M4.206 18.588v-1.529M7.024 14.02l-.242-1.511M7.748 18.551l-.241-1.511M1.325 14.02l.241-1.511M.6 18.551l.242-1.511"
      />
    </g>
  </svg>
);
